<div class="px-24 py-48">
  <h3 class="nhsuk-heading-m">
    {{ title }}
  </h3>
  <a
    (click)="navigateToLink()"
    (keydown.enter)="navigateToLink()"
    tabindex="0"
    class="nhsuk-u-visually-hidden chart-link"
    >{{ title }}</a
  >
  @if (!error) {
    @if (description) {
      <p class="nhsuk-body">{{ description }}</p>
    }
    <div style="display: flex; flex-wrap: wrap; gap: 20px; width: 100%">
      @for (chartConfig of chartDataArray; track $index) {
        <app-chart
          [chartData]="chartConfig.chartData"
          [chartType]="chartConfig.chartType"
          [chartOptions]="chartConfig.chartOptions"
          [customData]="chartConfig.customData"
        ></app-chart>
      }
    </div>
  } @else {
    <p>{{ error }}</p>
  }
</div>
